<template>
  <p>Have any feedback about this page? <a
    class="btn btn-default"
    target="_blank"
    :href="generatedFeedbackLink">Submit Feedback</a></p>
</template>

<script>
import { mapState } from 'vuex'
import $ from 'jquery'

export default {
  name: 'SubmitFeedback',
  props: {
    type: {
      type: String,
      required: true
    },
    uuid: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      googleFormBaseUrl:
        'https://docs.google.com/forms/d/e/1FAIpQLScN5SYu0YNCympe4S1XorZyiU7KJGcGhmZPhvyHD1WsparzLA/viewform?'
    }
  },
  computed: {
    ...mapState('user', ['user']),
    generatedFeedbackLink() {
      return `${this.googleFormBaseUrl}${$.param(this.formParams)}`
    },
    formParams() {
      return {
        'entry.511727829': this.user.name,
        'entry.13770077': this.user.email,
        'entry.305088804': this.title,
        'entry.1207187100': this.uuid,
        'entry.1819560062': this.subject,
        'entry.646615767': this.$store.state.currentUrl,
        'entry.2087380084': this.type,
        'entry.885705844': 'Toolkit'
      }
    }
  }
}
</script>

<style scoped>
p {
  margin-top: 48px;
}
</style>
